<template>
    <div class="alipay-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-wrapper">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i> 首页
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <i class="el-icon-truck"></i> 汽车列表
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 卡片内容 -->
        <el-card class="alipay-card" shadow="never">
            <!-- 搜索栏 -->
            <div class="search-bar">
                <el-form :inline="true" :model="searchForm" size="small">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="标题">
                                <el-input v-model="searchForm.title" clearable placeholder="请输入标题"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车系">
                                <el-cascader v-model="searchForm.style_ids" style="width: 100%"
                                    ref="cascaderCarStyle" @change="getval($event)"
                                    :props="{ value: 'id', label: 'name', children: 'children', checkStrictly: true }"
                                    :options="carStyleMenus" clearable></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="年份">
                                <el-select v-model="searchForm.year_id" filterable clearable default-first-option
                                    placeholder="请选择年份">
                                    <el-option v-for="item in carYearList" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" class="search-actions">
                            <el-button type="primary" @click="searchSubmit()">搜索</el-button>
                            <el-button type="success" @click="goAdd()">新增</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- 统计卡片（示例） -->
            <div class="stat-cards">
                <div class="stat-card" @click="searchSubmit()">
                    <div class="stat-icon total"><i class="el-icon-document"></i></div>
                    <div class="stat-info">
                        <div class="stat-value">{{ total }}</div>
                        <div class="stat-label">汽车总数</div>
                    </div>
                </div>
                <div class="stat-card">
                    <div class="stat-icon detect"><i class="el-icon-view"></i></div>
                    <div class="stat-info">
                        <div class="stat-value">{{ detectedCount }}</div>
                        <div class="stat-label">已检测</div>
                    </div>
                </div>
                <div class="stat-card">
                    <div class="stat-icon recommend"><i class="el-icon-star-on"></i></div>
                    <div class="stat-info">
                        <div class="stat-value">{{ recommendCount }}</div>
                        <div class="stat-label">推荐车型</div>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div class="table-wrapper">
                <el-table ref="multipleTable" :data="tableLoadData" stripe border size="medium"
                    v-loading="loading" element-loading-text="加载中..."
                    :header-cell-style="headerCellStyle" :row-style="rowStyle">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column label="标题" prop="title" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column label="车系" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.style && scope.row.style.parent ? scope.row.style.parent.name : '' }}
                            {{ scope.row.style ? scope.row.style.name : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="年份" prop="year.name" width="160" align="center"></el-table-column>
                    <el-table-column label="孔距" prop="pitch.name" width="100" align="center"></el-table-column>
                    <el-table-column label="中心孔" prop="center_bore" width="100" align="center"></el-table-column>
                    <el-table-column label="ET" prop="et" width="100" align="center"></el-table-column>
                    <el-table-column label="原车尺寸" prop="dimensions" width="120" align="center"></el-table-column>
                    <el-table-column label="是否检测" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.detections" size="small" type="success" effect="plain">是</el-tag>
                            <el-tag v-else size="small" type="danger" effect="plain">否</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="推荐" width="80" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_recommend == 1" class="recommend-star">★</span>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序" prop="sort" width="80" align="center"></el-table-column>
                    <el-table-column label="操作" width="280" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.file_url" type="text" class="operate-btn" @click="detectWheels(scope.row)">检测轮毂</el-button>
                            <el-button type="text" class="operate-btn" @click="goEdit(scope.row)">编辑</el-button>
                            <el-button type="text" class="operate-btn" @click="relationHub(scope.row)">关联轮毂</el-button>
                            <el-button type="text" class="operate-btn delete-btn" @click="handelDel(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 空状态 -->
            <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
                <i class="el-icon-truck"></i>
                <p>暂无汽车数据</p>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 轮毂关联抽屉 -->
        <el-drawer size="50%" title="轮毂关联" :visible.sync="drawerHub" :with-header="true" class="alipay-drawer">
            <div class="drawer-content">
                <el-form :model="hubForm" ref="hubFormRef" label-width="80px" size="small">
                    <el-form-item label="轮毂" prop="hub_id" required>
                        <el-input v-model="hubForm.hub_name" @click.native="openHubSelectDialog" clearable
                            placeholder="请点击选择多个轮毂" class="hub-input">
                            <span slot="suffix" class="select-suffix">...</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="分类" prop="category" required>
                        <el-select v-model="hubForm.category" placeholder="请选择分类" clearable>
                            <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="saveHubRelation" size="small">保存关联</el-button>
                    </el-form-item>
                </el-form>

                <!-- 已关联轮毂列表 -->
                <div class="hub-table-wrapper">
                    <el-table :data="hubList" stripe border size="small" row-key="id"
                        @row-click="handleHubRowClick" :row-class-name="({row}) => row.id === hubForm.hub_id ? 'selected-row' : ''">
                        <el-table-column label="序号" width="60" align="center">
                            <template #default="scope">{{ (pageNum1 - 1) * pageSize1 + scope.$index + 1 }}</template>
                        </el-table-column>
                        <el-table-column label="图片" width="80">
    <template slot-scope="scope">
        <el-image v-if="scope.row.goods && scope.row.goods.goods_img" 
            style="width: 50px; height: 50px" 
            :src="scope.row.goods.goods_img" 
            :preview-src-list="[scope.row.goods.goods_img]" 
            fit="cover">
        </el-image>
        <div v-else class="no-img">暂无图片</div>
    </template>
</el-table-column>
<el-table-column label="名称" min-width="150" show-overflow-tooltip>
    <template slot-scope="scope">
        {{ (scope.row.goods && scope.row.goods.goods_name) || '-' }}
    </template>
</el-table-column>
                        <el-table-column label="分类" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" effect="plain">{{ scope.row.cate_id == 1 ? '原装款' : '改装款' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" class="delete-btn" @click.stop="delHub(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-wrapper">
                        <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                            :current-page="pageNum1" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize1"
                            layout="total, sizes, prev, pager, next, jumper" :total="total1" small>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 轮毂选择弹窗（使用子组件 eHubList） -->
        <eHubList :formData="formData1" :visible.sync="visible1" :title="title1" v-on:eventChoose="eChooseHub" :closeForm="closeForm1" />

        <!-- 检测进度弹窗 -->
        <el-dialog :visible.sync="processing" :show-close="false" :close-on-click-modal="false" width="360px" class="loading-dialog">
            <div class="loading-content">
                <el-progress type="circle" :percentage="progress" :status="progress === 100 ? 'success' : undefined" />
                <div class="loading-text">{{ loadingText }}</div>
                <div class="loading-percent" v-if="progress > 0">{{ progress }}%</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import eHubList from "../common/eHubMultiList";
    import axios from 'axios'

    const API_BASE_URL = 'https://jm.shuangma88.com';
    const http = axios.create({
        baseURL: API_BASE_URL,
        timeout: 30000,
        headers: { 'Content-Type': 'application/json' }
    });
    http.interceptors.request.use(config => config);
    http.interceptors.response.use(res => res.data, error => Promise.reject(error));

    export default {
        name: "carList",
        components: { eHubList },
        data() {
            return {
                loading: false,
                selectedHubList: [],
                formData1: {}, title1: '', visible1: false,
                api: http,
                processing: false,
                progress: 0,
                loadingText: '处理中，请稍候...',
                carStyleMenus: [],
                pitch_id: '',
                drawerHub: false,
                hubList: [],
                total1: 0,
                pageNum1: 1,
                pageSize1: 20,
                hubForm: { hub_id: '', hub_name: '', category: '' },
                categoryOptions: [
                    { label: '原装款', value: '1' },
                    { label: '改装款', value: '2' }
                ],
                currentCarId: '',
                searchForm: { title: "", style_ids: [], style_id: '', year_id: '' },
                carYearList: [],
                tableLoadData: [],
                pageNum: 1,
                pageSize: 10,
                total: 0,
                dialogFormVisible: false,
                form: { name: '' }
            }
        },
        computed: {
            detectedCount() {
                return this.tableLoadData.filter(item => item.detections).length;
            },
            recommendCount() {
                return this.tableLoadData.filter(item => item.is_recommend == 1).length;
            }
        },
        created() {
            this.DataList();
            this.getCarStyleMenus();
            this.getCarYeaList();
        },
        methods: {
            headerCellStyle() {
                return { background: '#f5f7fa', color: '#1f2d3d', fontWeight: '500', fontSize: '14px', borderBottom: '1px solid #e4e7ed' };
            },
            rowStyle() { return { cursor: 'pointer' }; },
            indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1; },
            async detectWheels(item) {
                this.processing = true;
                this.progress = 30;
                this.loadingText = '正在检测轮毂...';
                try {
                    const formData = new FormData();
                    formData.append('car_url', item.file_url);
                    formData.append('conf', (this.confidence || 0.4).toString());
                    this.progress = 60;
                    const response = await this.api.post('/api/detect', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                    this.progress = 90;
                    if (response && response.detections) {
                        let param = {
                            access_token: sessionStorage.getItem('token'),
                            company_id: sessionStorage.getItem('company_id'),
                            id: item.id,
                            detections: JSON.stringify(response.detections)
                        };
                        await this.$axios.carinfoUpdateDetections(param);
                        this.resetList();
                    }
                    this.progress = 100;
                    this.$message.success('轮毂检测完成!');
                    setTimeout(() => { this.processing = false; this.progress = 0; }, 1000);
                } catch (error) {
                    this.processing = false;
                    this.progress = 0;
                    this.$message.error('检测失败: ' + (error.response?.data?.error || error.message));
                }
            },
            resetList() {
                this.total = 0;
                this.tableLoadData = [];
                this.pageNum = 1;
                this.DataList();
            },
            getCarStyleMenus() {
                this.$axios.findCarStyleTree({ access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id') })
                    .then(res => { if (res.code == 200) this.carStyleMenus = res.data; });
            },
            getCarYeaList() {
                this.$axios.findCarYearList({ access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id') })
                    .then(res => { if (res.code == 200) this.carYearList = res.data; });
            },
            getval() {
                const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
                this.searchForm.style_id = obj.length ? obj[0].data.id : "";
            },
            relationHub(row) {
                this.drawerHub = true;
                this.pitch_id = row.pitch_id;
                this.currentCarId = row.id;
                this.resetHubForm();
                this.getHubList();
            },
            closeForm1() { this.visible1 = false; },
            eChooseHub(list) {
                this.selectedHubList = list;
                this.hubForm.hub_name = list.map(item => item.goods_name).join('，');
                this.hubForm.hub_id = list.map(item => item.goods_id).join(',');
            },
            delHub(e) {
                this.$confirm('此操作将删除关联轮毂, 是否继续?', '提示', { type: 'warning' }).then(() => {
                    this.$axios.delCarGoods({ id: e.id, company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') })
                        .then(res => { if (res.code == 200) { this.$message.success(res.msg); this.getHubList(); } else this.$message.error(res.msg); });
                }).catch(() => { this.$message.info('已取消删除'); });
            },
            getHubList() {
                this.$axios.findCarGoodsListP({
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: this.pageNum1,
                    pageSize: this.pageSize1,
                    car_id: this.currentCarId
                }).then(res => { if (res.code == 200) { this.hubList = res.data.data; this.total1 = res.data.total; } });
            },
            openHubSelectDialog() {
                this.title1 = "选择轮毂";
                this.visible1 = true;
            },
            handleHubRowClick(row) {
                this.hubForm.hub_id = row.id;
                this.hubForm.hub_name = row.goods.goods_name;
            },
            resetHubForm() {
                this.hubForm = { hub_id: '', hub_name: '', category: '' };
                this.selectedHubList = [];
                if (this.$refs.hubFormRef) this.$refs.hubFormRef.resetFields();
            },
            saveHubRelation() {
                if (this.selectedHubList.length === 0) { this.$message.warning('请选择轮毂'); return; }
                if (!this.hubForm.category) { this.$message.warning('请选择分类'); return; }
                if (!this.currentCarId) { this.$message.warning('关联的汽车信息丢失'); return; }
                let promiseArr = {
                    access_token: sessionStorage.getItem('token'),
                    company_id: sessionStorage.getItem('company_id'),
                    car_id: this.currentCarId,
                    goods_id: this.hubForm.hub_id,
                    cate_id: this.hubForm.category
                };
                this.$axios.carGoodsSaveBatch(promiseArr).then(res => {
                    if (res.code == 200) {
                        this.$message.success('批量保存成功！');
                        this.drawerHub = false;
                        this.resetHubForm();
                        this.getHubList();
                    }
                }).catch(err => { this.$message.error('保存失败：' + err.message); });
            },
            goEdit(row) { this.$router.push({ path: '/carForm', query: { id: row.id } }); },
            goAdd() { this.$router.push('/carForm'); },
            DataList() {
                this.loading = true;
                const param = {
                    access_token: sessionStorage.getItem('token'),
                    company_id: sessionStorage.getItem('company_id'),
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                };
                if (this.searchForm.title) param.keywords = this.searchForm.title;
                if (this.searchForm.style_id) param.style_id = this.searchForm.style_id;
                if (this.searchForm.year_id) param.year_id = this.searchForm.year_id;
                this.$axios.findCarListP(param).then(res => {
                    if (res.code == 200) { this.tableLoadData = res.data.data; this.total = res.data.total; }
                    this.loading = false;
                }).catch(() => { this.loading = false; });
            },
            handleSizeChange(newSize) { this.pageSize = newSize; this.DataList(); },
            handleCurrentChange(newPage) { this.pageNum = newPage; this.DataList(); },
            handleSizeChange1(newSize) { this.pageSize1 = newSize; this.getHubList(); },
            handleCurrentChange1(newPage) { this.pageNum1 = newPage; this.getHubList(); },
            searchSubmit() { this.total = 0; this.pageNum = 1; this.tableLoadData = []; this.DataList(); },
            handelDel(row) {
                this.$confirm('此操作将删除记录,不能恢复, 是否继续?', '提示', { type: 'warning' })
                    .then(() => {
                        this.$axios.carDel({ id: row.id, company_id: sessionStorage.getItem('company_id'), access_token: sessionStorage.getItem('token') })
                            .then(res => { if (res.code == 200) { this.$message.success(res.msg); this.DataList(); } else this.$message.error(res.msg); });
                    }).catch(() => { this.$message.info('已取消删除'); });
            }
        }
    }
</script>

<style lang="scss" scoped>
.alipay-container {
    padding: 16px 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
    margin-bottom: 16px;
    .el-breadcrumb {
        font-size: 14px;
        i { margin-right: 4px; }
    }
}

.alipay-card {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    &:hover {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
    }
    ::v-deep .el-card__body {
        padding: 20px 24px;
    }
}

.search-bar {
    background: #f8f9fc;
    padding: 16px 20px;
    border-radius: 12px;
    margin-bottom: 20px;
    .el-form-item {
        margin-bottom: 0;
        width: 100%;
    }
    .el-form-item__label {
        font-size: 12px;
        padding-right: 8px;
        font-weight: 500;
        color: #606266;
    }
    .el-input ::v-deep .el-input__inner,
    .el-select ::v-deep .el-input__inner,
    .el-cascader ::v-deep .el-input__inner {
        border-radius: 20px;
    }
    .search-actions {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        .el-button {
            border-radius: 20px;
            padding: 8px 18px;
        }
        .el-button--primary {
            background: #1677ff;
            border-color: #1677ff;
            &:hover { background: #4096ff; border-color: #4096ff; }
        }
        .el-button--success {
            background: #00b578;
            border-color: #00b578;
            &:hover { background: #1acd8c; border-color: #1acd8c; }
        }
    }
}

.stat-cards {
    display: flex;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
    .stat-card {
        flex: 1;
        min-width: 160px;
        background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
        border-radius: 16px;
        padding: 20px;
        display: flex;
        align-items: center;
        gap: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: all 0.3s ease;
        cursor: pointer;
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        }
        .stat-icon {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            color: #fff;
            &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
            &.detect { background: linear-gradient(135deg, #00b578, #1acd8c); }
            &.recommend { background: linear-gradient(135deg, #faad14, #ffc53d); }
        }
        .stat-info {
            .stat-value {
                font-size: 28px;
                font-weight: 700;
                color: #1f2d3d;
                line-height: 1.2;
            }
            .stat-label {
                font-size: 13px;
                color: #8c8f98;
                margin-top: 4px;
            }
        }
    }
}

.table-wrapper {
    margin-bottom: 20px;
    min-height: 350px;
}
.el-table {
    border-radius: 12px;
    overflow: hidden;
    &::before { display: none; }
    th { background: #fafbfc !important; font-weight: 500; }
    td { border-bottom: 1px solid #f0f0f0; }
    .el-table__row:hover { background: #f0f7ff; }
}
.recommend-star {
    color: #faad14;
    font-size: 16px;
}
.operate-btn {
    color: #1677ff;
    margin: 0 4px;
    &:hover { color: #4096ff; }
    &.delete-btn {
        color: #fa6b6b;
        &:hover { color: #ff4d4f; }
    }
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #c0c4cc;
    i { font-size: 64px; }
    p { margin-top: 16px; font-size: 14px; }
}

.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
    ::v-deep .el-pagination .el-pager li.active {
        background: #1677ff;
        color: #fff;
    }
}

/* 抽屉样式 */
.alipay-drawer ::v-deep .el-drawer__header {
    background: #f5f7fa;
    padding: 16px 20px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 0;
    span { font-size: 16px; font-weight: 600; color: #1f2d3d; }
}
.drawer-content {
    padding: 20px;
}
.hub-input {
    cursor: pointer;
    .select-suffix {
        color: #1677ff;
        font-weight: bold;
        padding-right: 8px;
    }
}
.hub-table-wrapper {
    margin-top: 24px;
}
.selected-row {
    background-color: #e6f7ff !important;
}

.loading-dialog ::v-deep .el-dialog__body {
    text-align: center;
    padding: 30px;
}
.loading-content {
    .loading-text {
        margin-top: 15px;
        font-size: 14px;
        color: #666;
    }
    .loading-percent {
        margin-top: 8px;
        font-size: 13px;
        color: #1677ff;
    }
}
</style>